'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var linkedListUtils = require('./linked-list-utils.js');

const insertLinkedList = (item, config) => {
    const { format, list, factory } = config;
    linkedListUtils.assertItemCompatibility(item, format);
    linkedListUtils.assertPresence(item.nextId, list.items);
    linkedListUtils.assertPresence(item.previousId, list.items);
    const hasPrevious = item.previousId !== undefined;
    const previousId = hasPrevious
        ? item.previousId
        : linkedListUtils.findPreviousId(item.nextId, list);
    linkedListUtils.assertNewNodePosition(item, {
        previousId,
        list,
    });
    const newHeadId = item.nextId === list.headId ? item.id : list.headId;
    const newItems = Object.assign(Object.assign(Object.assign(Object.assign({}, list.items), (previousId ? {
        [previousId]: Object.assign(Object.assign({}, list.items[previousId]), { nextId: item.id }),
    } : {})), (hasPrevious && item.nextId ? {
        [item.nextId]: Object.assign(Object.assign({}, list.items[item.nextId]), (hasPrevious ? { previousId: item.id } : {})),
    } : {})), { [item.id]: item });
    return factory({
        headId: newHeadId,
        items: newItems,
    });
};

exports.insertLinkedList = insertLinkedList;
//# sourceMappingURL=insert-linked-list.js.map
